import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";
import { useRealtimeTable } from "./useRealtime";

const INBOX_REALTIME_KEYS = ["inbox-stats"];

export function useInboxStats() {
  useRealtimeTable("emails", INBOX_REALTIME_KEYS);
  useRealtimeTable("text_messages", INBOX_REALTIME_KEYS);
  const { user } = useAuth();
  return useQuery({
    queryKey: ["inbox-stats", user?.id],
    queryFn: async () => {
      if (!user) return { unreadEmails: 0, unreadTexts: 0, total: 0 };

      const [emailRes, textRes] = await Promise.all([
        supabase
          .from("emails")
          .select("id", { count: "exact", head: true })
          .eq("user_id", user.id)
          .eq("is_read", false),
        supabase
          .from("text_messages")
          .select("id", { count: "exact", head: true })
          .eq("user_id", user.id)
          .eq("is_read", false),
      ]);

      const unreadEmails = emailRes.count ?? 0;
      const unreadTexts = textRes.count ?? 0;

      return {
        unreadEmails,
        unreadTexts,
        total: unreadEmails + unreadTexts,
      };
    },
    enabled: !!user,
    refetchInterval: 60000, // refresh every minute
  });
}
